// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import store from './store'
import axios from 'axios'
import 'babel-polyfill'

import promise from 'es6-promise'

promise.polyfill()

Vue.config.productionTip = false

const url = process.env.VUE_APP_HOME;

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
      
      localStorage.clear();
      //var token = JSON.parse(localStorage.getItem('scientia-session-authorization')); 
      window.location = url;
    
  } else {
      return Promise.reject(error);
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js